import styled from "styled-components";

export const CreateRoleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-inline: 50px;
  position: relative;
  min-height: 100vh;
  padding-bottom: 100px;
`;

export const BottomNavigatorWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 60px;
  right: 0;
  z-index: 1000;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  border-top: 1px solid ${(props) => props.theme?.colors?.greySix || "rgba(0,0,0,0.04)"};
  padding: 16px 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

